<label
  class="option-group-label"
  [style.height.px]="_optionHeight"
  [style.line-height.px]="_optionHeight"
  >{{ label }}</label
>
<ng-content select="mdb-option"></ng-content>
